/* global routes, publish, PUB_SUB_EVENTS */

(function () {
  if (customElements.get('protection-plan')) return;

  class ProtectionPlan extends HTMLElement {
    connectedCallback() {
      this.modal = document.getElementById(this.dataset.modalId);
      this.showModalOnDecline = this.dataset.showModalOnDecline === 'true';
      this.productForm = this.findProductForm();
      this.form = this.productForm ? this.productForm.querySelector('form') : null;

      if (this.form) {
        this.boundOnSubmit = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.boundOnSubmit, { capture: true });
      }

      this.dynamicCheckout = this.productForm
        ? this.productForm.querySelector('.shopify-payment-button')
        : null;

      if (this.dynamicCheckout) {
        this.boundOnExpressClick = this.onExpressClick.bind(this);
        this.dynamicCheckout.addEventListener('click', this.boundOnExpressClick, { capture: true });
      }

      this.bindModalHandlers();
    }

    // 安全网。一旦锁上了 body 却因为组件被移除而永远收不到 close 事件
    //（Theme Editor 重渲染 section 时就会这样），页面会永久卡在 position:fixed
    // 上滚不动。宁可多解一次锁（unlockPageScroll 自带幂等守卫），
    // 也不能留下一个滚不动的商品页。
    disconnectedCallback() {
      this.unlockPageScroll();
    }

    findProductForm() {
      var el = this.parentElement;
      while (el) {
        if (el.tagName && (el.tagName.toLowerCase() === 'product-info' || (el.id && el.id.indexOf('MainProduct-') === 0))) {
          break;
        }
        el = el.parentElement;
      }
      return el ? el.querySelector('product-form') : null;
    }

    bindModalHandlers() {
      if (!this.modal) return;

      var closeBtn = this.modal.querySelector('[data-protection-modal-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.onModalDecline());

      var addBtn = this.modal.querySelector('[data-protection-modal-add]');
      if (addBtn) addBtn.addEventListener('click', () => this.onModalAdd());

      var declineBtn = this.modal.querySelector('[data-protection-modal-decline]');
      if (declineBtn) declineBtn.addEventListener('click', () => this.onModalDecline());

      this.modal.querySelectorAll('.protection-modal__plan input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => this.refreshModalSelection());
      });

      // ESC / Android 返回手势。此前这里是空操作，导致关掉弹窗 = 用户已经点过的
      // 那次 Add to Cart 被静默丢弃，什么都没进购物车、也没有任何反馈。
      // 注意这不是「保持原行为」的问题 —— 原来的 X 按钮走的就是 onModalDecline
      // （会真的 POST /cart/add.js），而 ESC 什么都不做，两个关闭入口的结果相反。
      // 弹窗只在用户已经选了「No thanks」并且已经点了 Add to Cart 之后才出现，
      // 所以任何一种关闭方式的真实意图都是「跳过加购保险，按我说的做」。
      this.modal.addEventListener('cancel', () => this.onModalDecline());

      // 所有关闭路径（按钮 / ESC / 返回手势）的唯一解锁点。
      this.modal.addEventListener('close', () => this.unlockPageScroll());

      this.refreshModalSelection();
    }

    lockPageScroll() {
      if (this.scrollLocked || !document.body) return;
      this.scrollLocked = true;
      this.lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.setProperty('--protection-modal-body-top', -this.lockedScrollY + 'px');
      document.documentElement.classList.add('protection-modal-open');
      document.body.classList.add('protection-modal-open');
    }

    unlockPageScroll() {
      if (!this.scrollLocked) return;
      this.scrollLocked = false;
      document.documentElement.classList.remove('protection-modal-open');
      document.body.classList.remove('protection-modal-open');
      document.body.style.removeProperty('--protection-modal-body-top');
      window.scrollTo(0, this.lockedScrollY || 0);
    }

    // 唯一的开弹窗入口，也是唯一上锁的地方。
    //
    // 判据只认 modal.open，不认 showModal() 有没有抛错 —— 这样「抛错」「静默失效
    // （存在但不生效且不抛）」「压根不支持 <dialog>」三种情况一起覆盖。没开起来就
    // 立刻解锁，否则会留下「页面锁死 + 看不到弹窗」的死局：close 永不触发，
    // 解锁点永远跑不到。
    //
    // 返回值语义是「弹窗现在开着吗」，不是「这次调用开成功了吗」。区别很关键：
    // 调用方把 false 当作「弹窗起不来，直接加购」。而调用方在 await 期间用户可以
    // 再点一次，两次点击都会越过外层的 open 守卫走到这里；若把「已经开着」当失败，
    // 第二次点击就会在弹窗正开着时静默加购一件不带保险的商品。已开着 = 成功。
    openProtectionModal() {
      if (!this.modal) return false;
      if (this.modal.open) return true;

      this.lockPageScroll();
      try {
        if (typeof this.modal.showModal === 'function') this.modal.showModal();
      } catch (err) {
        // 落到下面的 open 检查统一处理。
      }

      if (!this.modal.open) {
        this.unlockPageScroll();
        return false;
      }
      return true;
    }

    refreshModalSelection() {
      if (!this.modal) return;
      this.modal.querySelectorAll('.protection-modal__plan').forEach((plan) => {
        var input = plan.querySelector('input[type="radio"]');
        if (input) plan.classList.toggle('is-selected', input.checked);
      });
    }

    getSelectedRadio() {
      return this.querySelector('.product-protection__radio:checked');
    }

    syncModalToCurrentSelection() {
      if (!this.modal) return;
      var current = this.getSelectedRadio();
      var value = current ? current.value : 'decline';
      if (value === 'decline') return; // no change to modal
      var modalRadio = this.modal.querySelector('.protection-modal__plan input[value="' + value + '"]');
      if (modalRadio) {
        modalRadio.checked = true;
        this.refreshModalSelection();
      }
    }

    getSelectedProductOptions() {
      var productInfo = this.productForm ? this.productForm.closest('product-info') : document.querySelector('product-info');
      var optionGroups = productInfo ? productInfo.querySelectorAll('variant-selects .product-form__input') : [];
      var values = [];

      optionGroups.forEach(function (group) {
        var checkedInput = group.querySelector('input[type="radio"]:checked');
        var selectedOption = group.querySelector('select option:checked');
        var value = checkedInput ? checkedInput.value : selectedOption ? selectedOption.value : '';
        if (value) values.push(value);
      });

      return values;
    }

    getCurrentMainVariantId() {
      if (!this.form) return '';
      return this.form.querySelector('[name="id"]')?.value || '';
    }

    async getProductJson() {
      if (this.productJson) return this.productJson;
      if (this.productJsonPromise) return this.productJsonPromise;

      var productInfo = this.productForm ? this.productForm.closest('product-info') : document.querySelector('product-info');
      var productUrl = productInfo?.dataset?.url || window.location.pathname;
      this.productJsonPromise = fetch(productUrl + '.js')
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then((product) => {
          this.productJson = product;
          return product;
        })
        .catch(function () {
          return null;
        });

      return this.productJsonPromise;
    }

    async getCurrentMainVariant() {
      var variantId = this.getCurrentMainVariantId();
      if (!variantId) return null;

      var product = await this.getProductJson();
      var variants = product && Array.isArray(product.variants) ? product.variants : [];
      return variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      }) || null;
    }

    getVariantOptions(variant) {
      if (!variant) return [];
      if (Array.isArray(variant.options)) return variant.options;
      return [variant.option1, variant.option2, variant.option3].filter(function (option) {
        return option != null;
      });
    }

    setMainVariantId(variantId) {
      if (!variantId || !this.form) return;

      var productInfo = this.productForm
        ? this.productForm.closest('product-info')
        : document.querySelector('product-info');

      if (productInfo && typeof productInfo.updateVariantInputs === 'function') {
        productInfo.updateVariantInputs(variantId);
      }

      this.form.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    async syncMainVariantFromCurrentOptions() {
      var selectedOptions = this.getSelectedProductOptions();
      if (!selectedOptions.length) return true;

      var product = await this.getProductJson();
      var variants = product && Array.isArray(product.variants) ? product.variants : [];
      if (!variants.length) return true;

      var variant = variants.find((candidate) => {
        var variantOptions = this.getVariantOptions(candidate);
        return selectedOptions.every(function (value, index) {
          return !value || String(variantOptions[index]) === String(value);
        });
      });

      if (!variant) {
        this.productForm?.toggleSubmitButton?.(true, window.variantStrings?.unavailable);
        return false;
      }

      this.setMainVariantId(variant.id);
      this.productForm?.toggleSubmitButton?.(!variant.available, window.variantStrings?.soldOut);
      return Boolean(variant.available);
    }

    ensureModalVariantElement() {
      if (!this.modal) return null;

      var variantEl = this.modal.querySelector('[data-protection-modal-product-variant]');
      if (variantEl) return variantEl;

      var titleEl = this.modal.querySelector('.protection-modal__product-title');
      if (!titleEl || !titleEl.parentElement) return null;

      variantEl = document.createElement('p');
      variantEl.className = 'protection-modal__product-variant';
      variantEl.dataset.protectionModalProductVariant = '';
      titleEl.insertAdjacentElement('afterend', variantEl);
      return variantEl;
    }

    async refreshModalProductSummary() {
      if (!this.modal) return;

      var selectedOptions = this.getSelectedProductOptions();
      var variantText = selectedOptions.join(' / ');
      var currentVariant = await this.getCurrentMainVariant();
      if (currentVariant && currentVariant.title && currentVariant.title !== 'Default Title') {
        variantText = currentVariant.title;
      }

      var variantEl = this.ensureModalVariantElement();
      if (variantEl && variantText) variantEl.textContent = variantText;

      var productInfo = this.productForm ? this.productForm.closest('product-info') : document.querySelector('product-info');
      var priceEl = productInfo
        ? productInfo.querySelector('.price-item--sale:not([hidden]), .price-item--regular')
        : null;
      var modalPriceEl = this.modal.querySelector('[data-protection-modal-product-price]');
      if (modalPriceEl) {
        if (priceEl) {
          modalPriceEl.textContent = priceEl.textContent.trim();
        } else if (currentVariant && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          modalPriceEl.textContent = Shopify.formatMoney(currentVariant.price, window.money_format || '${{amount}}');
        }
      }

    }

    collectAvailablePlans() {
      // Walk all configured plan radios in this PDP block and snapshot them
      // as line item properties to attach to the MAIN cart item. The cart
      // picker reads these to render its 3-option list, so each product can
      // carry its own plan config without any global theme settings.
      var plans = {};
      var radios = this.querySelectorAll('.product-protection__radio[data-variant-id]');
      var idx = 1;
      var coverageNote = '';
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        if (!r.dataset.variantId || r.value === 'decline') continue;
        plans['_available_plan_' + idx + '_id'] = r.dataset.variantId;
        plans['_available_plan_' + idx + '_label'] = r.dataset.planLabel || '';
        plans['_available_plan_' + idx + '_value'] = r.dataset.planValue || '';
        if (!coverageNote && r.dataset.coverageNote) coverageNote = r.dataset.coverageNote;
        idx++;
      }
      if (idx === 1) return null;
      if (coverageNote) plans._available_plan_coverage_note = coverageNote;
      return plans;
    }

    async onSubmit(event) {
      var selected = this.getSelectedRadio();
      if (!selected) return;

      var value = selected.value;
      var variantId = selected.dataset.variantId;
      var planLabel = selected.dataset.planLabel || '';
      var planValue = selected.dataset.planValue || '';
      var coverageNote = selected.dataset.coverageNote || '';

      if (value === 'decline') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var declineSynced = await this.syncMainVariantFromCurrentOptions();
        if (!declineSynced || this.isMainSubmitDisabled()) return;

        if (this.showModalOnDecline && this.modal) {
          // 弹窗已经开着 = 第一次点击拥有它，后续点击直接忽略。
          if (this.modal.open) return;
          this.syncModalToCurrentSelection();
          await this.refreshModalProductSummary();
          // 弹窗开不起来时，绝不能把用户这次 Add to Cart 吞掉 ——
          // 直接按他要的、不带保险完成加购。
          if (!this.openProtectionModal()) {
            this.addToCart({ withProtection: false });
          }
          return;
        }
        // No modal: still intercept so we can attach available plan info to
        // the main item (so cart picker can offer plans later).
        this.addToCart({ withProtection: false });
        return;
      }

      // Plan selected
      if (!variantId) {
        // No variant id configured – let product-form add main only as a fallback
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var synced = await this.syncMainVariantFromCurrentOptions();
      if (!synced || this.isMainSubmitDisabled()) return;

      this.addToCart({
        withProtection: true,
        protectionVariantId: variantId,
        planLabel: planLabel,
        planValue: planValue,
        coverageNote: coverageNote,
      });
    }

    async onExpressClick(event) {
      var selected = this.getSelectedRadio();
      if (!selected) return;

      var value = selected.value;
      if (value === 'decline') return;

      var variantId = selected.dataset.variantId;
      if (!variantId) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var synced = await this.syncMainVariantFromCurrentOptions();
      if (!synced || this.isMainSubmitDisabled()) return;

      this.addToCart({
        withProtection: true,
        protectionVariantId: variantId,
        planLabel: selected.dataset.planLabel || '',
        planValue: selected.dataset.planValue || '',
        coverageNote: selected.dataset.coverageNote || '',
        redirectToCheckout: true,
      });
    }

    onModalAdd() {
      if (!this.modal) return;
      if (this.modal.dataset.protectionSubmitting === 'true') return;
      var checked = this.modal.querySelector('.protection-modal__plan input[type="radio"]:checked');
      if (!checked || !checked.dataset.variantId) return;

      var afterAdd = this.modal.dataset.afterAdd;
      this.modal.dataset.afterAdd = '';
      this.markModalSubmitting(true);
      this.modal.close();
      this.addToCart({
        withProtection: true,
        protectionVariantId: checked.dataset.variantId,
        planLabel: checked.dataset.planLabel || '',
        planValue: checked.dataset.planValue || '',
        coverageNote: checked.dataset.coverageNote || '',
        redirectToCheckout: afterAdd === 'checkout',
      });
    }

    onModalDecline() {
      if (!this.modal) return;
      if (this.modal.dataset.protectionSubmitting === 'true') return;
      var afterAdd = this.modal.dataset.afterAdd;
      this.modal.dataset.afterAdd = '';
      this.markModalSubmitting(true);
      this.modal.close();
      this.addToCart({
        withProtection: false,
        redirectToCheckout: afterAdd === 'checkout',
      });
    }

    async requestCheckout() {
      var selected = this.getSelectedRadio();

      if (!selected || selected.value === 'decline') {
        var declineSynced = await this.syncMainVariantFromCurrentOptions();
        if (!declineSynced || this.isMainSubmitDisabled()) return;
        this.addToCart({ withProtection: false, redirectToCheckout: true });
        return;
      }

      var variantId = selected.dataset.variantId;
      if (!variantId) {
        var fallbackSynced = await this.syncMainVariantFromCurrentOptions();
        if (!fallbackSynced || this.isMainSubmitDisabled()) return;
        this.addToCart({ withProtection: false, redirectToCheckout: true });
        return;
      }

      var synced = await this.syncMainVariantFromCurrentOptions();
      if (!synced || this.isMainSubmitDisabled()) return;

      this.addToCart({
        withProtection: true,
        protectionVariantId: variantId,
        planLabel: selected.dataset.planLabel || '',
        planValue: selected.dataset.planValue || '',
        coverageNote: selected.dataset.coverageNote || '',
        redirectToCheckout: true,
      });
    }

    setLoading(isLoading) {
      if (!this.form) return;
      var submitButton = this.form.querySelector('[type="submit"]');
      var spinner = this.form.querySelector('.loading__spinner');
      if (submitButton) {
        submitButton.classList.toggle('loading', isLoading);
        if (isLoading) submitButton.setAttribute('aria-disabled', 'true');
        else submitButton.removeAttribute('aria-disabled');
      }
      if (spinner) spinner.classList.toggle('hidden', !isLoading);
    }

    markModalSubmitting(isSubmitting) {
      if (!this.modal || !this.modal.dataset) return;
      this.modal.dataset.protectionSubmitting = isSubmitting ? 'true' : '';
    }

    isMainSubmitDisabled() {
      if (!this.form) return true;

      var submitButton = this.form.querySelector('[type="submit"]');
      var variantInput = this.form.querySelector('[name="id"]');
      var hasVariantId = !variantInput || variantInput.value !== '';

      return Boolean(
        !hasVariantId ||
          (submitButton && (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true'))
      );
    }

    // 单飞守卫 + 唯一清理点。此前每个 early-return 各自负责复位，
    // !synced 那条只复位了 markModalSubmitting、没复位 setLoading，
    // 漏掉一条就是按钮永久卡在 busy、用户再也加不了购。
    async addToCart(opts) {
      if (!this.form || this.addToCartInFlight) return;

      this.addToCartInFlight = true;
      try {
        if (window.CartOperations) await window.CartOperations.run(() => this.performAddToCart(opts));
        else await this.performAddToCart(opts);
      } finally {
        this.addToCartInFlight = false;
        this.markModalSubmitting(false);
        this.setLoading(false);
      }
    }

    async performAddToCart(opts) {
      if (!this.form) return;

      var synced = await this.syncMainVariantFromCurrentOptions();
      if (!synced) {
        this.showFormError('The selected option is currently unavailable.');
        return;
      }

      var formData = new FormData(this.form);
      var mainVariantId = formData.get('id');
      var quantity = parseInt(formData.get('quantity') || '1', 10) || 1;

      if (!mainVariantId) {
        console.error('[protection-flow] missing main variant id');
        this.showFormError('Add to cart failed. Please refresh the page and try again.');
        return;
      }

      var mainItem = { id: parseInt(mainVariantId, 10), quantity: quantity };

      // Snapshot this PDP's plan config onto the main item so the cart can
      // re-render the picker per-product (no global theme settings needed).
      var availablePlans = this.collectAvailablePlans();
      if (availablePlans) {
        mainItem.properties = availablePlans;

        // 拒保的主商品必须落在自己的 line item 上，不能和已投保的那条合并。
        //
        // 不打标记时两条加购的 properties 完全相同（上面的 _available_plan_*
        // 对 decline 路径也照挂），Shopify 会合并成一行 qty=2，「1 台投保 +
        // 1 台不投保」这个信息就此丢失；cart-protection-sync 随后按主商品数量
        // 对齐，把用户明确拒绝的那台也补上了保险。线上实测：应收 $157.99、
        // 实收 $177.98。
        //
        // 下划线前缀对顾客隐藏，所以它只是一个内部区分位：既阻止合并，也让
        // sync 在算「应投保数量」时能把这部分排除，从而不必牺牲「按件倍增」
        // 这条正常行为。只在确实配了计划时才打 —— 没有计划就谈不上拒保。
        if (!opts.withProtection) {
          mainItem.properties._protection_declined = 'true';
        }
      }

      var items = [mainItem];

      if (opts.withProtection && opts.protectionVariantId) {
        var protId = parseInt(opts.protectionVariantId, 10);
        if (!protId || protId < 1) {
          console.warn('[protection-flow] invalid protection variant id, adding main only:', opts.protectionVariantId);
        } else {
          var protectionProperties = {
            _protection_for_id: String(mainVariantId),
            _protection_plan_label: opts.planLabel || 'Protection Plan',
            _protection_plan_value: opts.planValue || '',
          };
          if (opts.coverageNote) {
            protectionProperties._protection_coverage_note = opts.coverageNote;
          }
          items.push({
            id: protId,
            quantity: quantity,
            properties: protectionProperties,
          });
        }
      }

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var sections = cart && typeof cart.getSectionsToRender === 'function'
        ? cart.getSectionsToRender().map(function (s) { return s.id; })
        : [];

      this.setLoading(true);

      try {
        var addUrl = (typeof routes !== 'undefined' && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js';
        var response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: items,
            sections: sections,
            sections_url: window.location.pathname,
          }),
        });

        var data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        if (opts.redirectToCheckout) {
          window.location.href = '/checkout';
          return;
        }

        if (cart && typeof cart.renderContents === 'function') {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'protection-flow',
              productVariantId: mainVariantId,
              cartData: data,
            });
          }
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

          // Hoist the main line item's fields onto data root so
          // <cart-notification>.renderContents can render the toast.
          //
          // Why: /cart/add.js with body { items: [...] } returns
          // { items: [...], sections: {...} } — and intentionally drops
          // the top-level LineItem fields (key, id, quantity, ...) that
          // a single-object add would carry. cart-notification.js reads
          // `parsedState.key` to build the per-item product slot
          // selector ([id="cart-notification-product-{key}"]). Without
          // a key, that selector matches nothing, querySelector returns
          // null, and `null.innerHTML` throws inside renderContents
          // before this.open() runs — the toast silently never appears.
          //
          // Always picking the non-protection (main) line keeps the
          // user-visible toast focused on the actual product they
          // added; the protection line is only relevant inside the
          // cart UI itself.
          var dataForRender = data;
          if (data && Array.isArray(data.items) && data.items.length > 0) {
            var mainLine = null;
            for (var li = 0; li < data.items.length; li++) {
              var line = data.items[li];
              var isProtection = line && line.properties && line.properties._protection_for_id;
              if (!isProtection) { mainLine = line; break; }
            }
            if (!mainLine) mainLine = data.items[0];
            dataForRender = Object.assign({}, data, mainLine);
          }
          try {
            cart.renderContents(dataForRender);
          } catch (renderError) {
            console.error('[protection-flow] cart rendering failed:', renderError);
            window.location = (typeof routes !== 'undefined' && routes.cart_url) ? routes.cart_url : '/cart';
            return;
          }
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          window.location = (typeof routes !== 'undefined' && routes.cart_url) ? routes.cart_url : '/cart';
        }
      } catch (err) {
        console.error('[protection-flow] add-to-cart failed:', err);
        this.showFormError(err.message || 'Add to cart failed.', mainVariantId, err);
      }
    }

    // 加购失败必须让用户看见。只 publish cartError 是不够的 —— 本主题里没有任何
    // 订阅者会把 protection-flow 的报错渲染出来（recipient-form 只认
    // source === 'product-form'），静默失败对加购率是纯损失。
    showFormError(message, mainVariantId, err) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'protection-flow',
          productVariantId: mainVariantId,
          message: message,
          error: err,
        });
      }
      if (!this.form) return;
      var errorEl = this.form.querySelector('.product-form__error-message');
      var errorWrap = this.form.querySelector('.product-form__error-message-wrapper');
      if (errorEl && errorWrap) {
        errorEl.textContent = message;
        errorWrap.removeAttribute('hidden');
      }
    }
  }

  customElements.define('protection-plan', ProtectionPlan);
})();
